// import React from 'react';
// import styled from 'styled-components';
// import JoinLogin from '../../Pages/Auth/JoinNowLogin';
import JoinRegister from '../../Pages/Auth/JoinRegister';
// import { isMobile } from '../../../Helper';

// const BannerWrapper = styled.div`
//   position: relative;
//   margin: 12px 0;
//   overflow: hidden;
//   border-radius: 0.75rem;
//     background: linear-gradient(135d 56, 0.7), /* Adjuseg, rgba(18, 20, 24, 0.8), /* #121418 with 80% opacity */ rgba(50, 55,ted second color for smooth transition */ rgba(27, 30, 31, 0.6) /* Original color */);
//   aspect-ratio: 4.4;
//   padding: 1rem 0.8rem;
//   box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 
//               0 4px 6px -2px rgba(0, 0, 0, 0.05);
  
//   @media (max-width: 768px) {
//     margin: 12px 0;
//     aspect-ratio: 4.4;
//   }
  
//   @media (max-width: 640px) {
//     margin: 12px 0;
//     aspect-ratio: 1.7;
//   }
// `;

// const BackgroundImage = styled.img`
//   position: absolute;
//   right: -38px;
//   top: 0;
//   height: 100%;
//   width: auto;
  
//   @media (max-width: 768px) {
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//     // object-position: right;
//   }
// `;

// const GameIcon = styled.img`
//   position: absolute;
//   right: 2%;
//   top: 50%;
//   width: 5.3%;
//   transform: translateY(-50%);
//   border-radius: 0.5rem;
  
//   @media (max-width: 768px) {
//     width: 8%;
//     right: 3%;
//   }
// `;

// const LogoImage = styled.img`
//   position: absolute;
//   top: 0;
//   left: 1.5%;
//   height: 96%;
//   display: none;
  
//   @media (min-width: 640px) {
//     display: block;
//     height: 90%;
//     top: 5%;
//   }
// `;

// const ContentWrapper = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0.75rem;
//   height: 100%;
//   display: flex;
//   flex-direction: column;
//   padding: 1rem 0;
//   transform: scale(1);
//   z-index: 1;

  
//   @media (min-width: 640px) {
//     left: 14%;
//     top: 6%;
//     height: auto;
//     align-items: center;
//     padding: 0;
//     text-align: center;
//   }
  
//   @media (max-width: 768px) {
//     left: 1rem;
//   }
// `;

// const Title = styled.div`
//   font-size: 30px;
//   font-weight: 800;
//   color: #fff;
//   text-align:left;
  
//   @media (min-width: 640px) {
//     font-size: 1.875rem;
//   }
  
//   @media (max-width: 768px) {
//     font-size: 1.5rem;
//   }
// `;

// const OfferBox = styled.div`
//   margin-top: 10px;
//   font-size: 1.125rem;
//   font-weight: 600;
//   border-radius: 12px;
//   color: #fff;
//   text-align:left;
  
//   @media (min-width: 640px) {
//     margin-top: 1rem;
//     background: rgba(176, 255, 216, 0.2);
//     padding: 0.75rem 3.75rem;
//     backdrop-filter: blur(4px);
//     text-align:left;
//   }
  
//   @media (max-width: 768px) {
//     // padding: 0.5rem 2rem;
//     margin-top: 0.5rem;
//     text-align:left;
//   }
  
//   @media (prefers-color-scheme: dark) {
//     @media (min-width: 640px) {
//       background: rgba(0, 0, 0, 0.2);
//     }
//   }
// `;

// const OfferText = styled.div`
//   font-size: 1rem;
//   font-weight: 600;
  
//   @media (min-width: 640px) {
//     font-size: 1.125rem;
//   }
  
//   @media (max-width: 768px) {
//     font-size: 0.875rem;
//   }
// `;

// const UpToText = styled.span`
//   font-size: 1.25rem;
//   font-weight: 800;
  
//   @media (min-width: 640px) {
//     margin-top: 0.25rem;
//     font-size: 1.5rem;
//   }
  
//   @media (max-width: 768px) {
//     font-size: 1.125rem;
//   }
// `;

// const AmountText = styled.span`
//   margin-left: 0.25rem;
//   font-size: 1.25rem;
//   font-weight: 800;
//   background: #25ee89;
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
  
//   @media (min-width: 640px) {
//     font-size: 1.5rem;
//   }
  
//   @media (max-width: 768px) {
//     font-size: 1.125rem;
//   }
// `;

// const JoinButton = styled.div`
//   height: 2.5rem;
//   margin-top: auto;
//   width: 7rem;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   //  background: #25ee89;
//    background:#25ee89;
//   color: black !important;
//   border: none;
//   border-radius: 0.5rem;
//   font-weight: 600;
//   cursor: pointer;
  
//   @media (min-width: 640px) {
//     margin-top: 1.25rem;
//     width: 15rem;
//   }
  
//   @media (max-width: 768px) {
//     width: 5rem;
//     height: 2.25rem;
//   }
  
//   &:hover {
//     opacity: 0.9;
//   }
// `;

// const BackgroundPattern = styled.div`
//   position: absolute;
//   top: 0;
//   right: 0;
//   left: 0;
//   bottom: 0;
//   width: 100%;
//   height: 100%;
//   background-image: url("/assets/images/bcgames/banner/bcbg.svg");
//   background-size: cover;
//   background-position: center;
//   background-repeat: no-repeat;
//   aspect-ratio: 4.6;
  
//   @media (max-width: 768px) {
//     aspect-ratio: 4.4;
//   }
  
//   @media (max-width: 640px) {
//     aspect-ratio: 1.7;
//   }
// `;

// const Banner = () => {
//   return (
//     <BannerWrapper>
//       <BackgroundPattern />
//      {
//       isMobile() ?  <BackgroundImage src="/assets/images/bcgames/banner/small.png" alt="Banner background" />: <BackgroundImage src="/assets/images/bcgames/banner/banner-2.png" alt="Banner background" />
//      }
//       {/* <GameIcon src="https://bc.game/assets/icon-g-DjQwb4.png" alt="Game icon" /> */}
//       {/* <LogoImage src="https://bc.game/assets/logo-BjYZztWT.png" alt="Logo" /> */}
//       <ContentWrapper>
//         <Title>Stay Untamed</Title>
//         <OfferBox>
//           <OfferText>Sign Up & Get</OfferText>
//           <UpToText>UP TO</UpToText>
//           <AmountText>$20,000.00</AmountText>
//           <OfferText>in Casino or Sports</OfferText>
//         </OfferBox>
//         <JoinButton>
//           <JoinRegister />
//         </JoinButton>
//       </ContentWrapper>
//     </BannerWrapper>
//   );
// };

// export default Banner;


import { useState, useEffect } from "react"
import styles from "./Banner.module.css"

const floatingIcons = ["🎲", "🃏", "💎", "🎯", "🏆", "💰", "⭐"]
const currencies = ["BTC", "ETH", "USDT", "LTC"]

// Generate random floating elements
const generateFloatingElements = (count) => {
  return Array.from({ length: count }, (_, i) => ({
    id: i,
    icon: floatingIcons[Math.floor(Math.random() * floatingIcons.length)],
    left: Math.random() * 100,
    top: Math.random() * 100,
    delay: Math.random() * 2,
    duration: 3 + Math.random() * 40,
    size: 0.8 + Math.random() * 0.4,
  }))
}

// Generate random numbers for counter animation
const generateRandomNumbers = () => {
  return Array.from({ length: 8 }, () => Math.floor(Math.random() * 10))
}

export default function Banner() {
  const [floatingElements] = useState(() => generateFloatingElements(6))
  const [currentAmount, setCurrentAmount] = useState("$20,000 in CASINO ")
  const [isHovered, setIsHovered] = useState(false)
  const [randomNumbers, setRandomNumbers] = useState(generateRandomNumbers())
  const [currentCurrency, setCurrentCurrency] = useState(0)

  // Animate the bonus amount
  useEffect(() => {
    const interval = setInterval(() => {
      setRandomNumbers(generateRandomNumbers())
    }, 500)

    return () => clearInterval(interval)
  }, [])
// Get current time and determine player count range
const getPlayerCount = () => {
  const now = new Date();
  const currentHour = now.getHours();
  
  let min, max;
  
  if (currentHour < 14) { // Before 2 PM (morning)
    min = 2900;
    max = 3100;
  } else if (currentHour < 19) { // After 2 PM but before 7 PM
    min = 3900;
    max = 4100;
  } else { // After 7 PM
    min = 5000;
    max = 5200;
  }
  
  // Generate random value within the range
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

const randomValue = getPlayerCount();

  // Rotate currencies
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentCurrency((prev) => (prev + 1) % currencies.length)
  //   }, 2000)

  //   return () => clearInterval(interval)
  // }, [])

  // Jackpot counter effect
  useEffect(() => {
    const amounts = ["$20,000 in CASINO " , "$25,000 in SPORTS",]
    let index = 0

    const interval = setInterval(() => {
      setCurrentAmount(amounts[index])
      index = (index + 1) % amounts.length
    }, 3000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className={styles.banner}>
      {/* Animated Background */}
      <div className={styles.backgroundAnimation}>
        <div className={styles.gradientOrb1}></div>
        <div className={styles.gradientOrb2}></div>
        <div className={styles.gradientOrb3}></div>
      </div>

      {/* Floating Elements */}
      <div className={styles.floatingContainer}>
        {floatingElements.map((element) => (
          <div
            key={element.id}
            className={styles.floatingElement}
            style={{
              left: `${element.left}%`,
              top: `${element.top}%`,
              animationDelay: `${element.delay}s`,
              animationDuration: `${element.duration}s`,
              fontSize: `${element.size}rem`,
            }}
          >
            {element.icon}
          </div>
        ))}
      </div>

      {/* Geometric Patterns */}
      <div className={styles.geometricPattern}>
        <div className={styles.triangle1}></div>
        <div className={styles.triangle2}></div>
        <div className={styles.triangle3}></div>
        <div className={styles.diamond1}></div>
        <div className={styles.diamond2}></div>
      </div>

      {/* Main Content */}
      <div className={styles.content}>
        <div className={styles.leftSection}>
          {/* Animated Title */}
          <h1 className={styles.mainTitle}>
            <strong className={styles.titleWord1}>Stay</strong>
            <strong className={styles.titleWord2}>Untamed</strong>
          </h1>

          {/* Subtitle with typing effect */}
          <div className={styles.subtitle}>
            Sign Up & Get UPTO
          </div>

          {/* Animated Amount */}
          <div className={styles.amountContainer}>
            {/* <strong className={styles.upTo}>UP TO</strong> */}
            <div className={styles.amountWrapper}>
              {/* <strong className={styles.currency}>$</strong> */}
              <strong className={styles.amount}>{currentAmount}</strong>
              {/* <div className={styles.cryptoIndicator}>
                <strong className={styles.cryptoText}>or {currencies[currentCurrency]}</strong>
              </div> */}
            </div>
          </div>

          
         
          {/* CTA Button with Dice */}
          <div className={styles.ctaSection}>

          <JoinRegister >
            {/* Animated CTA Button */}
            <button
              className={`${styles.ctaButton} ${isHovered ? styles.hovered : ""}`}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {/* <strong className={styles.buttonText}>Sign Up Now</strong> */}
              
              Sign Up Now
              


              
              <div className={styles.buttonGlow}></div>
              <div className={styles.buttonParticles}>
                {Array.from({ length: 6 }, (_, i) => (
                  <div key={i} className={styles.particle}></div>
                ))}
              </div>
            </button>
            </JoinRegister>

            {/* Dice Animation next to button */}
            <div className={styles.diceContainer}>
              <div className={styles.dice}>🎲</div>
              <div className={styles.dice}>🎲</div>
            </div>
          </div>

          {/* Live Stats */}
          <div className={styles.liveStats}>
            <div className={styles.statItem}>
              <strong className={styles.statLabel}>Players Online</strong>
              <strong className={styles.statValue}>{randomValue}</strong>

            </div>
            <div className={styles.statItem}>
              <strong className={styles.statLabel}>Games Available</strong>
              <strong className={styles.statValue}>15000+</strong>
            </div>
            <div className={styles.statItem}>
              <strong className={styles.statLabel}>Bonus Dist.</strong>
              <strong className={styles.statValue}>$160498+</strong>
            </div>
          </div>
        </div>

        {/* Right Section - Interactive Elements */}
        <div className={styles.rightSection}>
          {/* Poker Cards Animation */}
          <div className={styles.pokerCards}>
            <div className={styles.card}>♠️</div>
            <div className={styles.card}>♥️</div>
            <div className={styles.card}>♦️</div>
            <div className={styles.card}>♣️</div>
          </div>

          {/* Enhanced Roulette Wheel */}
          <div className={styles.enhancedRouletteWheel}>
            <div className={styles.rouletteTable}>
              <div className={styles.rouletteWheelContainer}>
                {/* Outer Ring */}
                <div className={styles.rouletteOuterRing}>
                  {/* Number segments */}
                  {Array.from({ length: 37 }, (_, i) => {
                    const number = i === 0 ? 0 : i
                    const isRed = [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36].includes(number)
                    const isBlack = number !== 0 && !isRed
                    return (
                      <div
                        key={i}
                        className={`${styles.rouletteSegment} ${
                          number === 0 ? styles.green : isRed ? styles.red : styles.black
                        }`}
                        style={{
                          transform: `rotate(${(360 / 37) * i}deg)`,
                        }}
                      >
                        <strong className={styles.segmentNumber}>{number}</strong>
                      </div>
                    )
                  })}
                </div>

                {/* Inner wheel */}
                <div className={styles.rouletteInnerWheel}>
                  <div className={styles.rouletteCenter}>
                    <div className={styles.rouletteLogo}>⭐</div>
                  </div>
                </div>

                {/* Ball */}
                <div className={styles.rouletteBall}></div>

                {/* Pointer */}
                <div className={styles.roulettePointer}></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Glow Effect */}
      <div className={styles.bottomGlow}></div>
    </div>
  )
}
